import { isObservable, makeAutoObservable } from "mobx";
import { v4 as uuid } from 'uuid';
import BasePaginationState from "../BasePagination/BasePaginationState";
var makeDefaultIndexDirectoryState = function () { return ({
    name: uuid(),
    viewMode: 'table',
    searchQuery: '',
}); };
var IndexDirectoryState = /** @class */ (function () {
    function IndexDirectoryState(options) {
        var _this = this;
        this.options = makeDefaultIndexDirectoryState();
        this.paginationState = new BasePaginationState();
        if (!options)
            return;
        if (isObservable(options)) {
            Object.entries(this.options).forEach(function (e) {
                var key = e[0];
                if (!(key in options)) {
                    options[key] = _this.options[key];
                }
            });
            this.options = options;
        }
        else {
            Object.assign(this.options, options);
        }
        if (options === null || options === void 0 ? void 0 : options.paginationState) {
            this.paginationState = new BasePaginationState(options.paginationState);
        }
        makeAutoObservable(this);
    }
    Object.defineProperty(IndexDirectoryState.prototype, "name", {
        get: function () { return this.options.name; },
        set: function (v) { this.options.name = v; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IndexDirectoryState.prototype, "searchByKeyName", {
        get: function () { return this.options.searchByKeyName; },
        set: function (v) { this.options.searchByKeyName = v; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IndexDirectoryState.prototype, "searchQuery", {
        get: function () { return this.options.searchQuery; },
        set: function (v) { this.options.searchQuery = v; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IndexDirectoryState.prototype, "sortByKeyName", {
        get: function () { return this.options.sortByKeyName; },
        set: function (v) { this.options.sortByKeyName = v; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IndexDirectoryState.prototype, "sortDirection", {
        get: function () { return this.options.sortDirection; },
        set: function (v) { this.options.sortDirection = v; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IndexDirectoryState.prototype, "viewMode", {
        get: function () { return this.options.viewMode; },
        set: function (v) { this.options.viewMode = v; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IndexDirectoryState.prototype, "searchable", {
        get: function () { return this.options.searchable || false; },
        set: function (v) { this.options.searchable = v; },
        enumerable: false,
        configurable: true
    });
    return IndexDirectoryState;
}());
export default IndexDirectoryState;
